import QUERY from '@/api_app/YesterdayBriefing'
import { Toast } from 'vant';

const getDefaultState = () => {
  return {
    GetYesterdayBriefing: null, //单/多店铺数据
    GetYesterdayShops: [], //模板消息的多店铺名称
    YesterdayCustomer: {}, //昨日客户/客户类型
  }
}

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
}

const actions = {
    
  GetYesterdayBriefing({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'GetYesterdayBriefing' ,params}).then(response => {
        const { data } = response
        // if(data.code!=1000){
        //   Toast(data.message)
        // }else{
          commit('SET_DATA',{ key:'GetYesterdayBriefing', data:data })
        // }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GetYesterdayShops({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'GetYesterdayShops' ,params}).then(response => {
        const { data } = response
        // if(data.code!=1000){
        //   Toast(data.message)
        // }else{
          commit('SET_DATA',{ key:'GetYesterdayShops', data:data })
        // }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  YesterdayCustomer({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'YesterdayCustomer' ,params}).then(response => {
        const { data } = response
        // if(data.code!=1000){
        //   Toast(data.message)
        // }else{
          commit('SET_DATA',{ key:'YesterdayCustomer', data:data })
        // }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

